import React from 'react';
import './SalesStatusToggle.css';

export default function SalesStatusToggle({ isActive, onToggle }) {
  return (
    <div className="filter-section status-section">
      <div className="filter-label">
        <span className="label-secondary">Status sprzedaży:</span>
        <span className="label-primary">{isActive ? ' Tylko dostępne' : ' Wszystkie'}</span>
      </div>
      <div 
        className={`toggle ${isActive ? 'active' : ''}`}
        onClick={onToggle}
      >
        <div className="toggle-track">
          <div className={`toggle-thumb ${isActive ? 'active' : ''}`} />
        </div>
      </div>
    </div>
  );
}